import React from 'react'
import Link from 'gatsby-link'
import { Nav, Navbar, NavItem, NavDropdown, MenuItem, Image, Badge } from 'react-bootstrap'

import logo from '../images/logoCodeBoxTopo.png'

const ListLink = props =>
    <Link to={props.to} style={{color: 'white'}}>
      {props.children}
    </Link>


const HeaderInterno = (props) => (
	<Navbar inverse collapseOnSelect fluid style={{maxWidth: '1000px', margin: '0 auto', zIndex: 40425432, background: `transparent`, border: `none`}}>
		<Navbar.Header>
			
      { (props.menu=='nivel1'?
          (<ListLink to="/"><img src={logo} style={styles.logo} alt="CodeBox Desenvolvimento de Sistemas - Curitiba/PR" /></ListLink>):
          (<Link to="/clientes"><span className="icon fa-arrow-left" style={{fontSize:'2rem', color: 'white'}} ></span></Link>)
        )
      }
			
			<Navbar.Toggle />
		</Navbar.Header>
		<Navbar.Collapse>
			<ul className="nav navbar-nav navbar-right">
        
        <li role="presentation">
          <ListLink to="/institucional">Institucional</ListLink>
        </li>
        <li role="presentation">
          <ListLink to="/servicos">Serviços</ListLink>
        </li>
        <li role="presentation">
          <ListLink to="/produtos">Produtos</ListLink>
        </li>
        <li role="presentation">
          <ListLink to="/clientes">Clientes</ListLink>
        </li>
        <li role="presentation">
          <ListLink to="/contato">Contato</ListLink>
        </li>
      </ul>
		
		</Navbar.Collapse>
	</Navbar>
);


/*
const HeaderInterno = (props) => (
  <header>
  <a href="/" style={{ textShadow: `none`, backgroundImage: `none`, textDecoration: `none`, textDecorationUnderline: 'none' }}>
    <img src={logo} style={styles.logo}/>
  </a>
  <ul style={{ listStyle: `none`, float: `right` }}>
    {props.pagina!='1Institucional' ? <ListLink to="/institucional">Institucional</ListLink> : null }
    {props.pagina!='1Servicos'      ? <ListLink to="/servicos">Serviços</ListLink> : null }
    {props.pagina!='1Clientes'      ? <ListLink to="/clientes">Clientes</ListLink> : null }
    {props.pagina!='1Contato'       ? <ListLink to="/contato">Contato</ListLink> : null }
  </ul>
  </header>
)
*/

const styles = {
 
  logo: {
    marginTop: '6px',
    marginLeft: '10px',
  },
  rect1: {
    top: 0,
    left: 0,
    right: -2.06,
    height: "9.83%",
    position: "absolute",
    backgroundColor: 'white',
    opacity: 1,
    height: 50
  },
  text1: {
    backgroundColor: "transparent",
    top: 24.45,
    left: 140.9,
    position: "absolute"
  }
};


export default HeaderInterno



// WEBPACK FOOTER //
// ./src/components/HeaderInterno.js